/**
 * TDS · Selector de canción de Spotify.
 *
 * Busca mientras se teclea contra el App Proxy de la tienda, deja elegir un
 * resultado y guarda la selección como propiedades de línea dentro del
 * formulario de producto, para que viaje al carrito y al pedido.
 *
 * Decisiones que importan:
 *   - Los campos ocultos se INYECTAN en el <form action="/cart/add">. Es el
 *     unico sitio desde el que Shopify recoge properties[...]; un input
 *     fuera del formulario no llega al carrito.
 *   - Debounce de 350 ms y cancelacion de la peticion anterior: sin eso,
 *     escribir "bohemian rhapsody" lanza 17 busquedas y pintan desordenadas.
 *   - Arranque resistente (load + MutationObserver), como el mockup 3D: en
 *     esta tienda el DOM de seccion puede reemplazarse tras cargar.
 */
(function () {
  'use strict';

  // Idioma de la pagina: los mensajes que ve el cliente salen en aleman,
  // ingles o italiano en /de, /en y /it; en cualquier otro, en español, como
  // siempre. Los nombres de las properties (Canción, Artista, Enlace Spotify)
  // NO se traducen: viajan al pedido y los lee el taller en español.
  var TDS_L = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "").slice(0, 2);

  var ESPERA_MS = 350;

  function crearOcultos(form, nombre, valor) {
    var sel = 'input[type="hidden"][name="properties[' + nombre.replace(/"/g, '\\"') + ']"]';
    var input = form.querySelector(sel);
    if (!valor) {
      if (input && input.parentNode) input.parentNode.removeChild(input);
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + nombre + ']';
      input.setAttribute('data-tds-sp-prop', '');
      form.appendChild(input);
    }
    input.value = valor;
  }

  function iniciar(raiz) {
    if (!raiz || raiz.__tdsSpotify) return;
    raiz.__tdsSpotify = true;

    var input = raiz.querySelector('[data-tds-sp-input]');
    var lista = raiz.querySelector('[data-tds-sp-lista]');
    var estado = raiz.querySelector('[data-tds-sp-estado]');
    var elegida = raiz.querySelector('[data-tds-sp-elegida]');
    var limpiar = raiz.querySelector('[data-tds-sp-limpiar]');
    var avisoEditor = raiz.querySelector('[data-tds-sp-aviso-editor]');
    if (!input || !lista) return;

    var endpoint = raiz.getAttribute('data-endpoint') || '/apps/personaliza/spotify/search';
    var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 8;
    var mercado = raiz.getAttribute('data-mercado') || 'ES';
    var minimo = parseInt(raiz.getAttribute('data-minimo'), 10) || 3;
    var propCancion = raiz.getAttribute('data-prop-cancion') || 'Canción';
    var propArtista = raiz.getAttribute('data-prop-artista') || 'Artista';
    var propUrl = raiz.getAttribute('data-prop-url') || 'Enlace Spotify';
    var obligatorio = raiz.getAttribute('data-obligatorio') === '1';
    var textoObligatorio =
      raiz.getAttribute('data-texto-obligatorio') ||
      (TDS_L === "de" ? "Wähle einen Song, bevor du weitermachst" : TDS_L === "en" ? "Choose a song before continuing" : TDS_L === "it" ? "Scegli una canzone prima di continuare" : 'Elige una canción antes de continuar');

    var temporizador = null;
    var enCurso = null;
    var resultados = [];
    var activo = -1;
    var seleccion = null;

    function form() {
      // Como app block, el bloque vive DENTRO del form de producto: ese es
      // el correcto aunque en la pagina haya otro (p. ej. un producto
      // destacado mas abajo). Como seccion suelta, se cae al primero.
      var propio = raiz.closest && raiz.closest('form[action*="/cart/add"]');
      return propio || document.querySelector('form[action*="/cart/add"]');
    }

    function decir(texto) {
      if (estado) estado.textContent = texto || '';
    }

    function cerrar() {
      lista.hidden = true;
      lista.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      resultados = [];
      activo = -1;
    }

    function marcarActivo(i) {
      var items = lista.querySelectorAll('[role="option"]');
      for (var k = 0; k < items.length; k++) {
        var on = k === i;
        items[k].classList.toggle('is-activo', on);
        items[k].setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          input.setAttribute('aria-activedescendant', items[k].id);
          if (items[k].scrollIntoView) items[k].scrollIntoView({ block: 'nearest' });
        }
      }
      activo = i;
    }

    function pintar(canciones) {
      resultados = canciones;
      lista.innerHTML = '';
      if (!canciones.length) {
        cerrar();
        decir(TDS_L === "de" ? "Keine Ergebnisse. Versuch es mit dem Künstlernamen." : TDS_L === "en" ? "No results. Try searching by artist." : TDS_L === "it" ? "Nessun risultato. Prova con il nome dell'artista." : 'Sin resultados. Prueba con el artista.');
        return;
      }
      for (var i = 0; i < canciones.length; i++) {
        var c = canciones[i];
        var li = document.createElement('li');
        li.className = 'tds-spotify__item';
        li.id = 'tds-sp-op-' + i + '-' + Math.abs(hash(c.id));
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('data-indice', String(i));
        li.innerHTML =
          (c.portada
            ? '<img class="tds-spotify__mini" src="' +
              escapar(c.portada) +
              '" alt="" width="40" height="40" loading="lazy">'
            : '<span class="tds-spotify__mini tds-spotify__mini--vacia" aria-hidden="true"></span>') +
          '<span class="tds-spotify__info">' +
          '<span class="tds-spotify__t">' + escapar(c.titulo) + '</span>' +
          '<span class="tds-spotify__a">' + escapar(c.artista) + '</span>' +
          '</span>' +
          '<span class="tds-spotify__dur">' + escapar(c.duracion || '') + '</span>';
        lista.appendChild(li);
      }
      lista.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      decir(
        TDS_L === "de" ? canciones.length + (canciones.length === 1 ? " Ergebnis" : " Ergebnisse") + ". Wähle mit den Pfeiltasten aus." :
        TDS_L === "en" ? canciones.length + (canciones.length === 1 ? " result" : " results") + ". Use the arrow keys to choose." :
        TDS_L === "it" ? canciones.length + (canciones.length === 1 ? " risultato" : " risultati") + ". Usa le frecce per scegliere." :
        canciones.length + ' resultados. Usa las flechas para elegir.'
      );
    }

    function hash(s) {
      var h = 0;
      for (var i = 0; i < String(s).length; i++) h = (h * 31 + String(s).charCodeAt(i)) | 0;
      return h;
    }

    function escapar(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buscar(q) {
      if (enCurso && enCurso.abort) {
        try { enCurso.abort(); } catch (e) { /* navegador sin AbortController */ }
      }
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      enCurso = ctrl;
      decir(TDS_L === "de" ? "Suche läuft …" : TDS_L === "en" ? "Searching…" : TDS_L === "it" ? "Ricerca in corso…" : 'Buscando…');
      var url =
        endpoint +
        '?q=' + encodeURIComponent(q) +
        '&limite=' + encodeURIComponent(limite) +
        '&mercado=' + encodeURIComponent(mercado);

      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, d: d }; });
        })
        .then(function (res) {
          if (!res.ok || !res.d || res.d.success !== true) {
            cerrar();
            // El aviso del servidor (App Proxy) viene escrito en español. En
            // /de, /en y /it se dice en el idioma de la pagina: el de
            // «Demasiadas búsquedas seguidas» se reconoce porque pide esperar,
            // y el resto cae al generico. En español, el del servidor tal cual.
            var freno = /^Demasiadas/.test((res.d && res.d.error) || '');
            decir(
              TDS_L === "de" ? (freno ? "Zu viele Suchanfragen hintereinander, warte einen Moment" : "Die Suche ist gerade nicht möglich.") :
              TDS_L === "en" ? (freno ? "Too many searches in a row, please wait a moment" : "Search isn't available right now.") :
              TDS_L === "it" ? (freno ? "Troppe ricerche di seguito, aspetta un momento" : "Impossibile cercare in questo momento.") :
              ((res.d && res.d.error) || 'No se pudo buscar ahora mismo.')
            );
            return;
          }
          pintar(res.d.canciones || []);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          cerrar();
          decir(TDS_L === "de" ? "Die Suche ist gerade nicht möglich." : TDS_L === "en" ? "Search isn't available right now." : TDS_L === "it" ? "Impossibile cercare in questo momento." : 'No se pudo buscar ahora mismo.');
        });
    }

    function elegir(i) {
      var c = resultados[i];
      if (!c) return;
      seleccion = c;
      cerrar();
      input.value = '';
      if (limpiar) limpiar.hidden = true;

      var portada = raiz.querySelector('[data-tds-sp-portada]');
      var tCancion = raiz.querySelector('[data-tds-sp-cancion]');
      var tArtista = raiz.querySelector('[data-tds-sp-artista]');
      var enlace = raiz.querySelector('[data-tds-sp-enlace]');
      if (portada) {
        if (c.portada) { portada.src = c.portada; portada.hidden = false; }
        else portada.hidden = true;
      }
      if (tCancion) tCancion.textContent = c.titulo;
      if (tArtista) tArtista.textContent = c.artista;
      if (enlace) enlace.href = c.url;
      if (elegida) elegida.hidden = false;

      guardar();
      decir(
        TDS_L === "de" ? "Song ausgewählt: " + c.titulo + " von " + c.artista :
        TDS_L === "en" ? "Song selected: " + c.titulo + " by " + c.artista :
        TDS_L === "it" ? "Canzone scelta: " + c.titulo + " di " + c.artista :
        'Canción elegida: ' + c.titulo + ' de ' + c.artista
      );
    }

    function guardar() {
      var f = form();
      if (!f) {
        if (avisoEditor) {
          avisoEditor.hidden = false;
          avisoEditor.textContent =
            TDS_L === "de" ? "Dieser Abschnitt muss auf einer Produktseite stehen: Es gibt kein Kaufformular, in dem der Song gespeichert werden kann." :
            TDS_L === "en" ? "This section needs to be on a product page: there's no purchase form to save the song in." :
            TDS_L === "it" ? "Questa sezione deve trovarsi in una pagina prodotto: non c'è nessun modulo d'acquisto in cui salvare la canzone." :
            'Esta sección necesita estar en una página de producto: no hay formulario de compra ' +
            'donde guardar la canción.';
        }
        return;
      }
      if (seleccion) {
        crearOcultos(f, propCancion, seleccion.titulo);
        crearOcultos(f, propArtista, seleccion.artista);
        crearOcultos(f, propUrl, seleccion.url);
      } else {
        crearOcultos(f, propCancion, '');
        crearOcultos(f, propArtista, '');
        crearOcultos(f, propUrl, '');
      }
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (limpiar) limpiar.hidden = q.length === 0;
      if (temporizador) clearTimeout(temporizador);
      if (q.length < minimo) {
        cerrar();
        decir('');
        return;
      }
      temporizador = setTimeout(function () { buscar(q); }, ESPERA_MS);
    });

    input.addEventListener('keydown', function (ev) {
      if (lista.hidden || !resultados.length) return;
      if (ev.key === 'ArrowDown') {
        ev.preventDefault();
        marcarActivo(activo + 1 >= resultados.length ? 0 : activo + 1);
      } else if (ev.key === 'ArrowUp') {
        ev.preventDefault();
        marcarActivo(activo - 1 < 0 ? resultados.length - 1 : activo - 1);
      } else if (ev.key === 'Enter') {
        if (activo >= 0) { ev.preventDefault(); elegir(activo); }
      } else if (ev.key === 'Escape') {
        cerrar();
      }
    });

    lista.addEventListener('click', function (ev) {
      var li = ev.target.closest ? ev.target.closest('[role="option"]') : null;
      if (!li) return;
      elegir(parseInt(li.getAttribute('data-indice'), 10));
    });

    if (limpiar) {
      limpiar.addEventListener('click', function () {
        input.value = '';
        limpiar.hidden = true;
        cerrar();
        decir('');
        input.focus();
      });
    }

    var cambiar = raiz.querySelector('[data-tds-sp-cambiar]');
    if (cambiar) {
      cambiar.addEventListener('click', function () {
        seleccion = null;
        if (elegida) elegida.hidden = true;
        guardar();
        input.focus();
      });
    }

    // Clic fuera: cerrar la lista sin perder lo escrito.
    document.addEventListener('click', function (ev) {
      if (!raiz.contains(ev.target)) cerrar();
    });

    // Si es obligatorio, se bloquea el envío del formulario sin canción.
    if (obligatorio) {
      var f = form();
      if (f && !f.__tdsSpotifyGuard) {
        f.__tdsSpotifyGuard = true;
        f.addEventListener(
          'submit',
          function (ev) {
            if (seleccion) return;
            ev.preventDefault();
            ev.stopPropagation();
            decir(textoObligatorio);
            raiz.scrollIntoView({ behavior: 'smooth', block: 'center' });
            input.focus();
          },
          true,
        );
      }
    }
  }

  function arrancar(ambito) {
    var nodos = (ambito || document).querySelectorAll('[data-tds-spotify]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  } else {
    arrancar(document);
  }
  window.addEventListener('load', function () { arrancar(document); });

  if ('MutationObserver' in window) {
    var vigilante = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodos = muts[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-tds-spotify]')) iniciar(n);
          else if (n.querySelectorAll) arrancar(n);
        }
      }
    });
    var arrancarVigilante = function () {
      if (document.body) vigilante.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) arrancarVigilante();
    else document.addEventListener('DOMContentLoaded', arrancarVigilante);
  }

  document.addEventListener('shopify:section:load', function (ev) { arrancar(ev.target); });
})();
